import clsx from 'clsx'
import React from 'react'

import { Shimmer } from '@wartek-id/shimmer'

import type { HTMLProps } from 'react'

const Header = (
  { children, className, ...otherProps }: HTMLProps<HTMLTableSectionElement>,
  ref: React.Ref<HTMLTableSectionElement> | undefined
) => {
  return (
    <thead
      ref={ref}
      {...otherProps}
      className={clsx(
        'bg-gray-5 !text-left border-b border-gray-20',
        className
      )}
    >
      <tr>{children}</tr>
    </thead>
  )
}

const HeaderItem = (
  { children, className, ...otherProps }: HTMLProps<HTMLTableCellElement>,
  ref: React.Ref<HTMLTableCellElement> | undefined
) => {
  return (
    <th
      ref={ref}
      {...otherProps}
      className={clsx('p-4 print:p-2 !font-semibold', className)}
    >
      {children}
    </th>
  )
}

const Body = (
  { children, ...otherProps }: HTMLProps<HTMLTableSectionElement>,
  ref: React.Ref<HTMLTableSectionElement> | undefined
) => {
  return (
    <tbody ref={ref} {...otherProps}>
      {children}
    </tbody>
  )
}

const Row = (
  { children, className, ...otherProps }: HTMLProps<HTMLTableRowElement>,
  ref: React.Ref<HTMLTableRowElement> | undefined
) => {
  return (
    <tr
      data-testid="row"
      ref={ref}
      {...otherProps}
      className={clsx('border-b border-gray-20 align-top', className)}
    >
      {children}
    </tr>
  )
}

const RowItem = (
  { children, className, ...otherProps }: HTMLProps<HTMLTableCellElement>,
  ref: React.Ref<HTMLTableCellElement> | undefined
) => {
  return (
    <td ref={ref} {...otherProps} className={clsx('p-4 print:p-2', className)}>
      {children}
    </td>
  )
}

export const TableShimmer = ({
  columns = 3,
  rows = 3,
}: {
  columns?: number
  rows?: number
}) => {
  return (
    <>
      {Array(rows)
        .fill('')
        .map((_, i) => (
          <TableRow key={i}>
            {Array(columns)
              .fill('')
              .map((_, j) => (
                <TableRowItem className="text-center" key={`${i}-${j}`}>
                  <Shimmer height="40px" width="100%" />
                </TableRowItem>
              ))}
          </TableRow>
        ))}
    </>
  )
}

export const Table = (
  { children, className, ...otherProps }: HTMLProps<HTMLTableElement>,
  ref: React.Ref<HTMLTableElement> | undefined
) => {
  return (
    <table ref={ref} {...otherProps} className={clsx('mt-4 w-full', className)}>
      {children}
    </table>
  )
}

export const TablePelaksanaanKinerja = React.forwardRef(Table)
export const TableHeader = React.forwardRef(Header)
export const TableHeaderItem = React.forwardRef(HeaderItem)
export const TableBody = React.forwardRef(Body)
export const TableRow = React.forwardRef(Row)
export const TableRowItem = React.forwardRef(RowItem)
